
export function _isNull(value){
    if(value === null || value === undefined || value === ""){
        return true;
    }else{
        return false;
    } 
}